import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"text-edit, prompts, comment, draft"} maskId="square-filled-radius-0-stroke-1-IconTextEdit"><path d="M18.5 3.79297L7 15.293V20.0001H11.7071L23.2071 8.50008L18.5 3.79297Z" fill="currentColor"/><path d="M1 5.00008V6.00008H10V5.00008H1Z" fill="currentColor"/><path d="M1 9.00008V10.0001H7V9.00008H1Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTextEdit;
